import { apiCollection, apiResource, apiFormSubmit, apiDelete, apiPut } from "@/util/request";
// 获取省市区
export const getArea = (params) => {
  return apiCollection({
    url: "/v1/common/Area",
    params,
  });
};
// 登录
export const login = (data) => {
  return apiResource({
    url: "/v1/app/MobileLogin",
    data,
  });
};
// 获取是否绑定过密码
export const getPwdStatus = (opts) => {
  return apiCollection({ url: "/v1/app/mobilelogin/pwd_status", params: opts });
};
// 密码登录
export const pwdLogin = (opts) => {
  return apiResource({ url: "/v1/app/mobilelogin/pwd_login", data: opts });
};
// 微信登录
export const wechatlogin = (data) => {
  return apiResource({
    url: "/v1/app/wechatlogin",
    data,
  });
};
// 加入我们
export const joinUs = (data) => {
  return apiResource({
    url: "/v1/app/JoinUs",
    data,
  });
};
// 荣誉殿堂&证书
// 1=荣誉殿堂，2=证书
export const getCertificate = (params) => {
  return apiCollection({
    url: "/v1/app/certificate",
    params,
  });
};
// 获取个人信息/v1/app/User
export const getUserInfo = (params) => {
  return apiCollection({
    url: "/v1/app/UserInfo",
    params,
  });
};
// 获取日历课程
export const getCourseDay = (params) => {
  return apiCollection({
    url: "/v1/app/CourseDay",
    params,
  });
};
export const saveUserInfo = (params) => {
  return apiResource({
    url: "/v1/app/UserInfo",
    params,
  });
};
// 文件上传
export const commonUpload = (data) => {
  return apiResource({
    url: "/v1/common/Upload",
    data,
  });
};
// 更新头像/v1/app/User
export const updateAvatar = (data) => {
  return apiResource({
    url: "/v1/app/User",
    data,
  });
};
// 发送验证码
// 接口错误
export const sendCode = (data) => {
  return apiResource({
    url: "/v1/common/Captcha",
    data,
  });
};
// 创建课程订单
export const courseOrder = (data) => {
  return apiResource({
    url: "/v1/app/courseOrder",
    data,
  });
};
// 上传支付凭证
export const uploadPlayImg = (data) => {
  return apiPut({
    url: `/v1/app/CourseOrder/${data.order_sn}`,
    data,
  });
};
// 我的课程列表/v1/app/userOrder
export const getUserOrder = (params) => {
  return apiCollection({
    url: "/v1/app/userOrder",
    params,
  });
};
// 我的课程目录
export const getCourseDirectory = (params) => {
  return apiCollection({
    url: `/v1/app/userOrder/${params.id}`,
    params,
  });
};
// 课程详情
export const getCourseOrder = (params) => {
  return apiCollection({
    url: `/v1/app/courseOrder/${params.id}`,
    params,
  });
};
// 获取学校风采类别
export const getArticleCate = (params) => {
  return apiCollection({
    url: `/v1/app/ArticleCate`,
    params,
  });
};
// 获取学校风采列表
export const getArticle = (params) => {
  return apiCollection({
    url: `/v1/app/Article`,
    params,
  });
};
// 获取学校风采列表详情
export const getArticleDetail = (params) => {
  return apiCollection({
    url: `/v1/app/Article/${params.uuid}`,
    params,
  });
};
// 获取学校风采评论列表
export const getArticleEvaluate = (params) => {
  return apiCollection({
    url: `/v1/app/ArticleEvaluate`,
    params,
  });
};
// 发布评论
export const ArticleEvaluate = (data) => {
  return apiResource({
    url: "/v1/app/ArticleEvaluate",
    data,
  });
};
// 预约线下课程
export const goInlineCourse = (data) => {
  return apiResource({
    url: "/v1/app/CourseSubscribe",
    data,
  });
};
// 观看线上视频
export const lookOnlineVideo = (params) => {
  return apiCollection({
    url: `/v1/app/CourseView/${params.id}`,
    params,
  });
};
// 记录课程观看时间
export const recordCourseTime = (data) => {
  return apiResource({
    url: "/v1/app/CourseTime",
    data,
  });
};
// 课程视频播放完成
export const recordCourseOver = (data) => {
  return apiResource({
    url: "/v1/app/CourseOver",
    data,
  });
};
// 课程订单取消
export const CourseOrderCancel = (data) => {
  return apiResource({
    url: "/v1/app/CourseOrderCancel",
    data,
  });
};
// 获取课程表
export const getCourseWeek = (params) => {
  return apiCollection({
    url: "/v1/app/CourseWeek",
    params,
  });
};
// 获取月课程表
export const getCourseMonth = (params) => {
  return apiCollection({
    url: "/v1/app/CourseMonth",
    params,
  });
};
// 获取书斋分类列表
export const getGoodCate = (params) => {
  return apiCollection({
    url: `/v1/app/GoodCate`,
    params,
  });
};
// 获取书斋列表
export const getGood = (params) => {
  return apiCollection({
    url: `/v1/app/good`,
    params,
  });
};
// 获取书斋列表详情
export const getGoodDetail = (params) => {
  return apiCollection({
    url: `/v1/app/good/${params.uuid}`,
    params,
  });
};
// 获取书斋评论列表
export const getGoodEvaluate = (params) => {
  return apiCollection({
    url: `/v1/app/GoodEvaluate`,
    params,
  });
};
// 获取购物车列表
export const getGoodCar = (params) => {
  return apiCollection({
    url: `/v1/app/GoodCar`,
    params,
  });
};
// 加入购物车
export const postGoodCar = (data) => {
  return apiResource({
    url: "/v1/app/GoodCar",
    data,
  });
};
// 书斋发表评论
export const postGoodEvaluate = (data) => {
  return apiResource({
    url: "/v1/app/GoodEvaluate",
    data,
  });
};
// 书斋订单获取地址列表
export const getAddressList = (params) => {
  return apiCollection({
    url: `/v1/app/Address`,
    params,
  });
};
// 获取直播分类
export const getLiveCateList = (params) => {
  return apiCollection({
    url: `/v1/app/LiveCate`,
    params,
  });
};
// 获取直播列表
export const getliveList = (params) => {
  return apiCollection({
    url: `/v1/app/live`,
    params,
  });
};
// 获取直播地址/v1/app/LivePush
export const getLivePush = (params) => {
  return apiCollection({
    url: `/v1/app/LivePush/${params.uuid}`,
    params,
  });
};
// 直播计时/v1/app/LiveOption
export const LiveOption = (data) => {
  return apiResource({
    url: "/v1/app/LiveOption",
    data,
  });
};
// 直播详情/v1/app/live/{uuid}
export const getLiveDetail = (params) => {
  return apiCollection({
    url: `/v1/app/live/${params.uuid}`,
    params,
  });
};
// 获取弹幕列表/v1/app/Barrage
export const getBarrage = (params) => {
  return apiCollection({
    url: "/v1/app/Barrage",
    params,
  });
};
// 获取能力培训列表
export const getCourseList = (params) => {
  return apiCollection({
    url: `/v1/app/course`,
    params,
  });
};
// 获取能力培训热搜关键词
export const getCourseCat = (params) => {
  return apiCollection({
    url: `/v1/app/CourseCat`,
    params,
  });
};
// 获取能力培训课程详情
export const getCourseDetail = (params) => {
  return apiCollection({
    url: `/v1/app/course/${params.uuid}`,
  });
};
// 获取能力培训评论列表
export const getCourseEvaluate = (params) => {
  return apiCollection({
    url: `/v1/app/CourseEvaluate`,
    params,
  });
};
// 能力培训评论发布
export const postCourseEvaluate = (data) => {
  return apiResource({
    url: "/v1/app/CourseEvaluate",
    data,
  });
};
// 检测课程/v1/app/courseCheck
export const courseCheck = (data) => {
  return apiResource({
    url: "/v1/app/courseCheck",
    data,
  });
};
// 提交个人档案
export const archiveSubmit = (data) => {
  return apiResource({
    url: "/v1/app/Archive",
    data,
  });
};
// 获取直播订单
export const getLiveOrder = (params) => {
  return apiCollection({
    url: `/v1/app/LiveOrder`,
    params,
  });
};
export const getLiveOrderDetail = (params) => {
  return apiCollection({
    url: `/v1/app/LiveOrder/${params.order_sn}`,
    params,
  });
};
// 创建
export const createPlayOrder = (data) => {
  return apiResource({
    url: `/v1/app/LiveOrder`,
    data,
  });
};
// 删除购物车选中项
export const selectDelete = (data) => {
  return apiResource({
    url: "/v1/app/GoodCarBatch",
    data,
  });
};
// 删除购物车中商品数量为0的商品
export const goodsDelete = (data) => {
  return apiDelete({
    url: `/v1/app/GoodCar/${data.id}`,
    data,
  });
};
// 考试列表/v1/app/paper
export const getPaperList = (params) => {
  return apiCollection({
    url: `/v1/app/paper`,
    params,
  });
};
// 试卷列表/v1/app/subject
export const getSubjectList = (params) => {
  return apiCollection({
    url: `/v1/app/subject`,
    params,
  });
};
// 获取学校列表
export const getSchoolList = (params) => {
  return apiCollection({
    url: `/v1/app/school`,
    params,
  });
};
// 线下考试报名
export const offlineExamReport = (data) => {
  return apiResource({
    url: "/v1/app/ExamReport",
    data,
  });
};
// 线上考试提交
export const ReceiverSubject = (data) => {
  return apiResource({
    url: "/v1/app/ReceiverSubject",
    data,
  });
};
// 线上考试结果
export const getResultList = (params) => {
  return apiCollection({
    url: `/v1/app/ReceiverSubject`,
    params,
  });
};
// 获取线上考试总分
export const getTotalScore = (params) => {
  return apiCollection({
    url: `/v1/app/TotalScore/${params.id}`,
    params,
  });
};
// 获取首页内容/v1/app/Home
export const getHomeData = (params) => {
  return apiCollection({
    url: `/v1/app/Home`,
    params,
  });
};
// 获取订单详情/v1/app/GoodOrder
export const getGoodOrder = (params) => {
  return apiCollection({
    url: `/v1/app/GoodOrder/${params.order_sn}`,
  });
};
// 获取订单列表/v1/app/GoodOrder
export const getGoodOrderList = (params) => {
  return apiCollection({
    url: `/v1/app/GoodOrder`,
    params,
  });
};
// 创建订单
export const createGoodOrder = (data) => {
  return apiResource({
    url: `/v1/app/GoodOrder`,
    data,
  });
};
// 更新订单
export const upDateGoodOrder = (data) => {
  return apiPut({
    url: `/v1/app/GoodOrder/${data.order_sn}`,
    data,
  });
};
// 支付订单/v1/app/Pay
export const PayGoodOrder = (data) => {
  return apiResource({
    url: `/v1/app/Pay`,
    data,
  });
};
export const checkPay = (data) => {
  return apiPut({
    url: `/v1/app/Pay/${data.order_sn}`,
    data,
  });
};
// 取消订单/v1/app/GoodOrderCancel
export const GoodOrderCancel = (data) => {
  return apiResource({
    url: `/v1/app/GoodOrderCancel`,
    data,
  });
};
// 确认收货/v1/app/GoodOrderShip
export const GoodOrderShip = (data) => {
  return apiResource({
    url: `/v1/app/GoodOrderShip`,
    data,
  });
};
// 地址/v1/app/Address
export const getAddress = (params) => {
  return apiCollection({
    url: `/v1/app/Address`,
    params,
  });
};
export const createAddress = (data) => {
  return apiResource({
    url: `/v1/app/Address`,
    data,
  });
};
export const deleteAddress = (data) => {
  return apiDelete({
    url: `/v1/app/Address/${data.id}`,
  });
};
export const updateAddress = (data) => {
  return apiPut({
    url: `/v1/app/Address/${data.id}`,
    data,
  });
};
export const getAddressDetail = (params) => {
  return apiCollection({
    url: `/v1/app/Address/${params.id}`,
  });
};
// 申请开票/v1/app/GoodOrderTicket
export const GoodOrderTicket = (data) => {
  return apiResource({
    url: `/v1/app/GoodOrderTicket`,
    data,
  });
};
// 获取消息列表
export const getMsgList = (params) => {
  return apiCollection({
    url: `/v1/app/Message`,
    params,
  });
};
// 标记当前消息为已读
export const msgRead = (data) => {
  return apiResource({
    url: `/v1/app/Message`,
    data,
  });
};
// 优惠券列表
export const getCouponUserList = (params) => {
  return apiCollection({
    url: `/v1/app/CouponUser`,
    params,
  });
};
export const getCouponUser = (params) => {
  return apiCollection({
    url: `/v1/app/couponUser`,
    params,
  });
};



// WEBPACK FOOTER //
// ./src/util/api.js